import {createContext} from "react";

const EventContext = createContext({
    customEvent: {},
    setCustomEvent: () => {},
    customEventForDelete: {},
    setCustomEventForDelete: () => {},
});

export default EventContext;